import {Alert, Col, Row} from "react-bootstrap";
import React from "react";

const ErrorMessages=({errorList}) =>{

    return <Row className={"text-center"}>
        <Col> {errorList.map((message,index)=> <Alert key={index} variant="danger"> {message}</Alert>)}
        </Col>
    </Row>
};
export default ErrorMessages;